import { Element } from 'html-react-parser';
import { FrameworkError, warn } from '../utils/index.js';
const BLOCK_MISSING = '_HEADLESS_/_MISSING__BLOCK_';
export const DEFAULT_BLOCK_ELEMENT = new Element('div', {
    'data-wp-block': JSON.stringify({}),
    'data-wp-block-name': BLOCK_MISSING,
});
export const defaultElement = DEFAULT_BLOCK_ELEMENT;
/**
 * Parses Json without throwing errors
 *
 * @param json Serialized JSON
 * @returns JSON object
 */
function safeParsing(json) {
    let parsed = {};
    try {
        parsed = JSON.parse(json);
    }
    catch (e) {
        // do nothing
    }
    return parsed;
}
/**
 * Checks whether the node is a WordPress block
 *
 * @param node DomNode
 *
 * @returns
 */
export function isWordPressBlock(node) {
    return (typeof node.attribs['data-wp-block-name'] !== 'undefined' &&
        typeof node.attribs['data-wp-block'] !== 'undefined');
}
/**
 * Returns the block name and attributes
 *
 * @param node DomNode
 *
 * @returns
 */
export function parseBlockAttributes(node) {
    if (typeof node === 'undefined') {
        throw new FrameworkError('You are calling `parseBlockAttributes` on a undefined node');
    }
    if (!isWordPressBlock(node)) {
        warn('[parseBlockAttributes] You are using the `parseBlockAttributes` hook in a node that is not a block.');
    }
    const blockName = node.attribs['data-wp-block-name'] || '';
    if (blockName === BLOCK_MISSING) {
        if (typeof node === 'undefined') {
            throw new FrameworkError('You are calling `parseBlockAttributes` on a undefined node');
        }
    }
    const attrs = node.attribs['data-wp-block']
        ? safeParsing(node.attribs['data-wp-block'])
        : {};
    if (attrs.style) {
        attrs.styleConfig = attrs.style;
        delete attrs.style;
    }
    return { attributes: attrs, name: blockName, className: node.attribs.class };
}
